import { useMutation, UseMutationResult } from 'react-query'
import { errorAlert, loadingAlert, successAlert } from '../../../../utils/alert'
import { api } from '../../../api'
import { localConfig } from '../../../../Configs/localConfig'

type Microrganismos = {
  cod_microrganismo: number
  concentracao: string
}

interface PropsPostBioInsumos {
  nome: string
  descricao: string
  cod_fabricante: number
  cod_categoria_produto: number
  origem: number
  formulacao: number
  aplicacao: number[]
  tecnologia: number
  volume_dose: number
  doses_por_hectare: number
  finalidades: number[]
  microrganismos: Microrganismos[]
  microrganismos_remover?: number[]
  finalidades_remover?: number[]
  aplicacao_remover?: number[]
  refetch: () => void
}

export const usePostBioInsumo = (): {
  carregando_salvar_bioInsumo: boolean
  mutate_bioInsumo: (params: PropsPostBioInsumos) => void
  isSuccess_bioInsumo: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostBioInsumos> = useMutation(
    async (params: PropsPostBioInsumos) => {
      const {
        nome,
        descricao,
        cod_fabricante,
        cod_categoria_produto,
        origem,
        formulacao,
        aplicacao,
        tecnologia,
        volume_dose,
        doses_por_hectare,
        finalidades,
        microrganismos,
        microrganismos_remover,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .post(`recomendacao/bioinsumo?codConta=${localConfig()?.conta}`, {
          nome: nome,
          descricao: descricao,
          cod_fabricante: cod_fabricante,
          cod_categoria_produto: cod_categoria_produto,
          origem: origem,
          formulacao: formulacao,
          aplicacao: aplicacao,
          tecnologia: tecnologia,
          volume_dose: volume_dose,
          doses_por_hectare: doses_por_hectare,
          finalidades: finalidades,
          microrganismos: microrganismos,
          microrganismos_remover: microrganismos_remover
        })
        .then((response: any) => {
          successAlert('BioInsumo cadastrado com sucesso!', 5000, 'loading')
          refetch()
          return response
        })
        .catch((error: any) => {
          if (error?.response?.data?.error[0]?.msg) {
            error.response.data.error.forEach((data) => {
              errorAlert(data?.msg[0] ?? 'Falha ao salvar bioInsumo!', 5000, 'loading')
            })
          } else {
            errorAlert(error.response.data.error ?? 'Falha ao salvar bioInsumo!', 5000, 'loading')
          }

          throw error
        })
    }
  )

  return {
    carregando_salvar_bioInsumo: mutation.isLoading,
    mutate_bioInsumo: mutation.mutate,
    isSuccess_bioInsumo: mutation.isSuccess,
  }
}

export const usePutBioInsumo = (
  cod: number
): {
  carregando_edit_bioInsumo: boolean
  mutate_edit_bioInsumo: (params: PropsPostBioInsumos) => void
  isSuccess_edit_bioInsumo: boolean
} => {
  const mutation: UseMutationResult<Response, Error, PropsPostBioInsumos> = useMutation(
    async (params: PropsPostBioInsumos) => {
      const {
        nome,
        descricao,
        cod_fabricante,
        cod_categoria_produto,
        origem,
        formulacao,
        aplicacao,
        aplicacao_remover,
        tecnologia,
        volume_dose,
        doses_por_hectare,
        finalidades,
        finalidades_remover,
        microrganismos,
        refetch,
      } = params

      loadingAlert({ msg: 'Salvando...', id: 'loading' })

      return api
        .put(`recomendacao/bioinsumo/${cod}?codConta=${localConfig()?.conta}`, {
          nome: nome,
          descricao: descricao,
          cod_fabricante: cod_fabricante,
          cod_categoria_produto: cod_categoria_produto,
          origem: origem,
          formulacao: formulacao,
          aplicacao: aplicacao,
          tecnologia: tecnologia,
          volume_dose: volume_dose,
          doses_por_hectare: doses_por_hectare,
          finalidades: finalidades,
          finalidades_remover,
          aplicacao_remover,
          microrganismos: microrganismos,
        })
        .then((response: any) => {
          successAlert('BioInsumo atualizado com sucesso!', 5000, 'loading')
          refetch()
          return response
        })
        .catch((error: any) => {
          console.log('err', error)
          errorAlert(
            error?.response?.data?.error[0]?.msg[0] ?? 'Falha ao editar o bioInsumo!',
            5000,
            'loading'
          )
          throw error
        })
    }
  )

  return {
    carregando_edit_bioInsumo: mutation.isLoading,
    mutate_edit_bioInsumo: mutation.mutate,
    isSuccess_edit_bioInsumo: mutation.isSuccess,
  }
}